import Toastr from 'toastr/build/toastr.min'
import 'toastr/build/toastr.css'

// Function to escape HTML characters
function escapeHtml(html) {
  if (typeof html !== 'string') {
    return html
  }

  return html
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

// Overriding the Toastr methods to escape HTML characters in the messages
const originalToastrSuccess = Toastr.success
const originalToastrError = Toastr.error
const originalToastrWarning = Toastr.warning
const originalToastrInfo = Toastr.info

Toastr.success = (message, title, options) => {
  return originalToastrSuccess(escapeHtml(message), title, options)
}

Toastr.error = (message, title, options) => {
  return originalToastrError(escapeHtml(message), title, options)
}

Toastr.warning = (message, title, options) => {
  return originalToastrWarning(escapeHtml(message), title, options)
}

Toastr.info = (message, title, options) => {
  return originalToastrInfo(escapeHtml(message), title, options)
}

Toastr.options = {
  preventDuplicates: true,
  preventOpenDuplicates: true,
  progressBar: true,
  ...(localStorage.getItem('Locale') === 'ar' && {
    rtl: true,
    positionClass: 'toast-top-left',
  }),
}

export { Toastr }
